// TODO: uncomment when functionality to upload plots in UI is fixed
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CLIMATE_RISK_FACT_TYPES,
  ClimateRiskRatingOrder,
  PlotReportFactLabelNameEnum,
  Scenario,
} from '@/api/rest/resources/types/fact';
import { WidgetType } from '@/api/rest/resources/types/widget';
// eslint-disable-next-line import/no-cycle
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { usePlotFacts } from '@/pages/shared/hooks/usePlotFact';
import { getFactFromFactArray } from '@/pages/shared/hooks/utils';
import { isNullish } from '@/utils/booleans';

import { PlotCardWrapper } from '../PlotCardWrapper';

export const ClimateRisk = () => {
  const { t } = useTranslation();

  return (
    <PlotCardWrapper name={t('global.analysis.carbonStorageAg')}>
      <ClimateRiskCard />
    </PlotCardWrapper>
  );
};

const ClimateRiskCard: FC = () => {
  const facts = usePlotFacts(Object.keys(CLIMATE_RISK_FACT_TYPES)) ?? [];

  const risks = facts
    .map((fact) => {
      return getFactFromFactArray(facts, fact.name, {
        [PlotReportFactLabelNameEnum.scenario]: Scenario.baseline,
      });
    })
    .filter((risk) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return !isNullish(risk?.value) && typeof (risk?.value as Record<string, any>).value === 'number';
    })
    .sort((a, b) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const aRating = (a?.value as Record<string, any>).rating;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const bRating = (b?.value as Record<string, any>).rating;
      return ClimateRiskRatingOrder[aRating as keyof typeof ClimateRiskRatingOrder] >
        ClimateRiskRatingOrder[bRating as keyof typeof ClimateRiskRatingOrder]
        ? -1
        : 1;
    })
    .map((risk) => risk?.name);

  const riskOverviewConfig = {
    name: 'climate_risk_overview',
    type: WidgetType.o_c_risk_overview,
    visible: facts.length > 0,
    relatedData: {
      className: 'flex flex-row flex-wrap gap-4',
      risks,
    },
  };

  return <WidgetSlotRenderer nestedWidget={riskOverviewConfig} />;
};
